function addMonths(date, monthsToAdd) {
  const result = new Date(date)
  const originalDay = result.getDate()

  result.setMonth(result.getMonth() + monthsToAdd)

  // If the day changed, it means we overflowed (e.g., Jan 31 + 1 month -> Mar 3)
  // Set to the last day of the previous month instead
  if (result.getDate() !== originalDay) {
    result.setDate(0)
  }

  return result
}

export function getRenewalDate(fromDate = new Date(), locale = 'en-US', intervalMonths = 1) {
  const renewalDate = addMonths(fromDate, intervalMonths)

  return renewalDate.toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
